module.exports = angular.module('cartographer.plugin.layer.thames21', [])

module.exports.run $DI (
  crtLayer
  crtFeatureLayer
  crtAttributeLayer
  crtMarkerColor
  crtMapCollaborationModel
  crtMapPermissionModel
  thames21SlowFlowSurveyType
  thames21SlowFlowSuitability
  thames21SlowFlowVegetationType
  thames21SlowFlowPondType
  thames21SlowFlowServiceType
  thames21SlowFlowFeatureType
) ->
  createWaterQualityLayer = (id, name) ->
    crtFeatureLayer.create({
      id
      name
      atlasMapId: id
      defaultMapEngine: "atlas"
      selectionRadius: 50
      attributeGroups: [
        crtFeatureLayer.createAttributeGroup(id, name, [
          crtAttributeLayer.createThreshold("ph", "pH", null, [
            { value: 1  , color: crtMarkerColor.ph(1)  , label: "1"  }
            { value: 2  , color: crtMarkerColor.ph(2)  , label: "2"  }
            { value: 3  , color: crtMarkerColor.ph(3)  , label: "3"  }
            { value: 4  , color: crtMarkerColor.ph(4)  , label: "4"  }
            { value: 5  , color: crtMarkerColor.ph(5)  , label: "5"  }
            { value: 6  , color: crtMarkerColor.ph(6)  , label: "6"  }
            { value: 7  , color: crtMarkerColor.ph(7)  , label: "7"  }
            { value: 8  , color: crtMarkerColor.ph(8)  , label: "8"  }
            { value: 9  , color: crtMarkerColor.ph(9)  , label: "9"  }
            { value: 10 , color: crtMarkerColor.ph(10) , label: "10" }
            { value: 11 , color: crtMarkerColor.ph(11) , label: "11" }
            { value: 12 , color: crtMarkerColor.ph(12) , label: "12" }
            { value: 13 , color: crtMarkerColor.ph(13) , label: "13" }
            { value: 14 , color: crtMarkerColor.ph(14) , label: "14" }
          ])
          crtAttributeLayer.createRange("temperature", "Temperature", "C", [
            { minValue: null, maxValue:    3, color: crtMarkerColor.create("#2e3090"), label:    "<3" }
            { minValue:    3, maxValue:    6, color: crtMarkerColor.create("#0f4ca0"), label:   "3-5" }
            { minValue:    6, maxValue:    9, color: crtMarkerColor.create("#0865b1"), label:   "6-8" }
            { minValue:    9, maxValue:   12, color: crtMarkerColor.create("#0c7cc4"), label:  "9-11" }
            { minValue:   12, maxValue:   15, color: crtMarkerColor.create("#1094d8"), label: "12-14" }
            { minValue:   15, maxValue:   18, color: crtMarkerColor.create("#14aded"), label: "15-17" }
            { minValue:   18, maxValue:   21, color: crtMarkerColor.create("#15a9c2"), label: "18-20" }
            { minValue:   21, maxValue:   24, color: crtMarkerColor.create("#6ea59f"), label: "21-23" }
            { minValue:   24, maxValue:   29, color: crtMarkerColor.create("#ea8133"), label: "24-28" }
            { minValue:   29, maxValue: null, color: crtMarkerColor.create("#be2432"), label:   "29+" }
          ])
          crtAttributeLayer.createThreshold("turbidity", "Turbidity", "NTU", [
            { value: 0   , color: crtMarkerColor.create("#00acec") , label: "<12" }
            { value: 12  , color: crtMarkerColor.create("#00aad0") , label: "12"  }
            { value: 13  , color: crtMarkerColor.create("#24a8b9") , label: "13"  }
            { value: 14  , color: crtMarkerColor.create("#66a6a2") , label: "14"  }
            { value: 15  , color: crtMarkerColor.create("#8ba48d") , label: "15"  }
            { value: 17  , color: crtMarkerColor.create("#a9a178") , label: "17"  }
            { value: 19  , color: crtMarkerColor.create("#c49e60") , label: "19"  }
            { value: 21  , color: crtMarkerColor.create("#dd9948") , label: "21"  }
            { value: 25  , color: crtMarkerColor.create("#f69532") , label: "25"  }
            { value: 30  , color: crtMarkerColor.create("#e28b32") , label: "30"  }
            { value: 40  , color: crtMarkerColor.create("#cf8033") , label: "40"  }
            { value: 50  , color: crtMarkerColor.create("#be7633") , label: "50"  }
            { value: 75  , color: crtMarkerColor.create("#ae6d32") , label: "75"  }
            { value: 100 , color: crtMarkerColor.create("#9e6531") , label: "100" }
            { value: 150 , color: crtMarkerColor.create("#905d2f") , label: "150" }
            { value: 200 , color: crtMarkerColor.create("#82552e") , label: "200" }
            { value: 240 , color: crtMarkerColor.create("#754d2c") , label: "240" }
          ])
          crtAttributeLayer.createThreshold("dissolvedOxygen", "Dissolved Oxygen", "ppm", [
            { value: 0  , color: crtMarkerColor.quality(0.0)  , label: "0"   }
            { value: 1  , color: crtMarkerColor.quality(0.2)  , label: "1"   }
            { value: 2  , color: crtMarkerColor.quality(0.4)  , label: "2"   }
            { value: 4  , color: crtMarkerColor.quality(0.5)  , label: "4"   }
            { value: 6  , color: crtMarkerColor.quality(0.7)  , label: "6"   }
            { value: 8  , color: crtMarkerColor.quality(0.8)  , label: "8"   }
            { value: 10 , color: crtMarkerColor.quality(1.0) , label: "10+" }
          ])
          crtAttributeLayer.createLookup("coliforms", "Coliforms", null, [
            { value: false , color: crtMarkerColor.quality(0.8) , label: "Absent (good)" }
            { value: true  , color: crtMarkerColor.quality(0.2) , label: "Present (bad)" }
          ])
        ])
      ]
    })

  waterQuality = createWaterQualityLayer("thames21WaterQuality", "Water Quality")

  thamesWaterQuality = createWaterQualityLayer("thames21ThamesWaterQuality", "Thames Water Quality")

  createCountLitterAttribute = (id, name, unit = "items") ->
    crtAttributeLayer.createThreshold(id, name, unit, [
      { value: 0   , color: crtMarkerColor.quality(0.4) , label: "0-9"   }
      { value: 10  , color: crtMarkerColor.quality(0.3) , label: "10-29" }
      { value: 30  , color: crtMarkerColor.quality(0.2) , label: "30-49" }
      { value: 50  , color: crtMarkerColor.quality(0.1) , label: "50-99" }
      { value: 100 , color: crtMarkerColor.quality(0.0) , label: "100+"  }
    ])

  createPolystyreneCoverLitterAttribute = (id, name) ->
    crtAttributeLayer.createLookup(id, name, null, [
      { value: "50-100" , color: crtMarkerColor.quality(0.0) , label: "50-100% cover" }
      { value: "20-49"  , color: crtMarkerColor.quality(0.1) , label: "20-49% cover"  }
      { value: "10-19"  , color: crtMarkerColor.quality(0.2) , label: "10-19% cover"  }
      { value: "5-9"    , color: crtMarkerColor.quality(0.3) , label: "5-9% cover"    }
      { value: "0-4"    , color: crtMarkerColor.quality(0.4) , label: ">0-4% cover"   }
    ])

  litter = crtFeatureLayer.create({
    id: "thames21Litter"
    name: "Litter"
    atlasMapId: "thames21Litter"
    defaultMapEngine: "atlas"
    selectionRadius: 50
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("litter", "Litter Collected", [
        createCountLitterAttribute("foodRelated", "Food Related")
        createCountLitterAttribute("packaging", "Packaging")
        createCountLitterAttribute("sewageRelated", "Sewage Related")
        createCountLitterAttribute("unidentifiedPlastic", "Unidentified Plastic")
        createPolystyreneCoverLitterAttribute("unidentifiedPolystyrene", "Unidentified Polystyrene")
      ])
    ]
  })

  greenWallModule = crtFeatureLayer.createPlaceholder({
    id: "thames21GreenWallModule"
    name: "Green Wall Module"
    atlasMapId: "thames21GreenWallModule"
    defaultMapEngine: "atlas"
  })

  rapidAppraisal  = crtFeatureLayer.createPlaceholder({
    id: "thames21RapidAppraisal"
    name: "Rapid Appraisal"
    atlasMapId: "thames21RapidAppraisal"
    defaultMapEngine: "atlas"
  })

  vegetation      = crtFeatureLayer.createPlaceholder({
    id: "thames21Vegetation"
    name: "Vegetation"
    atlasMapId: "thames21Vegetation"
    defaultMapEngine: "atlas"
  })

  booleanLookup = (id, name, falseLabel, trueLabel) ->
    crtAttributeLayer.createLookup(id, name, null, [
      { value: false , color: crtMarkerColor.quality(0.2) , label: falseLabel }
      { value: true  , color: crtMarkerColor.quality(0.8) , label: trueLabel  }
    ])

  badgedGroupEvent = crtFeatureLayer.create({
    id: "thames21BadgedGroupEvent"
    name: "River Action Group Event"
    defaultMapEngine: "atlas"
    selectionRadius: 50
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("badgedGroupEvent", "River Action Group Event", [
        crtAttributeLayer.createThreshold("numberOfVolunteers", "Number of Volunteers", null, [
          { value: 0   , color: crtMarkerColor.numeric(0.0) , label: "0-9"   }
          { value: 10  , color: crtMarkerColor.numeric(0.3) , label: "10-29" }
          { value: 30  , color: crtMarkerColor.numeric(0.5) , label: "30-49" }
          { value: 50  , color: crtMarkerColor.numeric(0.8) , label: "50-99" }
          { value: 100 , color: crtMarkerColor.numeric(1.0) , label: "100+"  }
        ])
        createCountLitterAttribute("rubbishBagsCollected", "Rubbish Collected", "bags")
        createCountLitterAttribute("largeRubbishCount", "Large Rubbish Collected", "items")
      ])
    ]
  })

  slowFlow = crtFeatureLayer.create({
    id: "Thames21SlowFlow"
    name: "Slow the Flow"
    atlasMapId: "Thames21SlowFlow"
    defaultMapEngine: "atlas"
    selectionRadius: 50
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("general", "General", [
        crtAttributeLayer.createAutoLookup("site", "Site")
        crtAttributeLayer.createEnumLookup("surveyType", "New/existing feature", null, thames21SlowFlowSurveyType)
      ])
      crtFeatureLayer.createAttributeGroup("new", "New NFM features", [
        crtAttributeLayer.createEnumLookup("newFeatureSuitability", "Suitability of location", null, thames21SlowFlowSuitability)
        crtAttributeLayer.createEnumLookup("newFeatureVegetationType", "Type of woodland/hedgerow", null, thames21SlowFlowVegetationType)
        crtAttributeLayer.createEnumLookup("newFeaturePondType", "Type of pond", null, thames21SlowFlowPondType)
        crtAttributeLayer.createEnumLookup("newFeatureServiceType", "NFM service potential", null, thames21SlowFlowServiceType)
      ])
      crtFeatureLayer.createAttributeGroup("existing", "Existing NFM features", [
        crtAttributeLayer.createEnumLookup("existingFeatureType", "Type of existing structure", null, thames21SlowFlowFeatureType),
        crtAttributeLayer.createEnumLookup("existingFeatureServiceType", "NFM service provided", null, thames21SlowFlowServiceType),
        crtAttributeLayer.createAutoThreshold("existingFeatureStorageArea", "Storage area", "m2"),
      ])
    ]
  })

  crtLayer.registerPlugin(waterQuality)
  crtLayer.registerPlugin(thamesWaterQuality)
  crtLayer.registerPlugin(litter)
  crtLayer.registerPlugin(greenWallModule)
  crtLayer.registerPlugin(rapidAppraisal)
  crtLayer.registerPlugin(vegetation)
  crtLayer.registerPlugin(badgedGroupEvent)
  crtLayer.registerPlugin(slowFlow)

  return
